import { useTranslate } from '@va/localization';
import { TextFilter } from '@va/shared/feature-filters';
import { useMemo } from 'react';

/**
 * @deprecated
 * replace with useUTMFilters('adCampaignLabel')
 */
export const useAdCampaignLabelFilter = () => {
  const translate = useTranslate();
  return useMemo(
    () =>
      new TextFilter({
        id: 'adCampaignLabel',
        name: 'adCampaignLabel',
        label: translate('filters.adCampaignLabel'),
        inputProps: { label: translate('filters.placeholder.adCampaignLabel') },
      }),
    [translate],
  );
};
